import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Input, Component, OnInit, Inject, LOCALE_ID } from "@angular/core";
import { AppCurrencyPipe } from "src/app/services/CommonService/custom.currency.pipe";
import { tBillPayService } from "src/app/services/tBillPay.service";

@Component({
  selector: "app-paid-change-pay-receipt-cert",
  templateUrl: "./paid-change-pay-receipt-cert.component.html",
  styleUrls: ["./paid-change-pay-receipt-cert.component.css"],
})
export class PaidChangePayReceiptCertComponent implements OnInit {
  @Input() paymentNumber: string;

  isLoading = true;

  constructor(
    public activeModal: NgbActiveModal,
    private billPayService: tBillPayService,
    private currencyPipe: AppCurrencyPipe,
    @Inject(LOCALE_ID) public locale: string
  ) {}

  ngOnInit(): void {
    this.getData(this.paymentNumber);
  }

  receiptData: ARAccountPaidBillReceiptModel =
    new ARAccountPaidBillReceiptModel();
  items: BIllItemDescModel[] = [];
  extraRemark = "";
  showOutstanding = false;

  getData(paymentNumber: string) {
    this.isLoading = true;
    this.billPayService
      .getARAccountPaidBillReceipt(paymentNumber)
      .subscribe((x) => {
        // console.table(x);
        this.receiptData = x;
        this.setItems(x.invoices[0].biDetails);
        if (x.isFirstPA && x.invoiceNumbers.length === 1) {
          this.showOutstanding = true;
        }
        this.isLoading = !this.isLoading;
      });
  }

  getPaymentMethodNames() {
    // console.table(this.receiptData.paymentMethods);
    if (this.receiptData.isFirstPA) {
      return this.receiptData.paymentMethods
        ? this.receiptData.paymentMethods
            .map(
              (x) =>
                x.name +
                ` ${this.currencyPipe.transform(
                  x.amount * -1,
                  "HKD",
                  "symbol",
                  "0.0-0",
                  "zh-Hans-HK"
                )}`
            )
            .join(", ")
        : "";
    }
    return this.receiptData.paymentMethods
      ? this.receiptData.paymentMethods.map((x) => x.name).join(", ")
      : "";
  }

  getTotal() {
    // return this.receiptData.detail.map(x=> x.itemArAmount).reduce((a,b)=>a+b,0);
    return 0;
  }

  setItems(biDetails?: BIllItemDescModel[]) {
    this.items = [];

    if (
      biDetails &&
      this.receiptData.invoiceNumbers.length === 1 &&
      this.receiptData.isFirstPA
    ) {
      this.items = biDetails;
    } else {
      this.items.push(
        ...[
          new BIllItemDescModel(
            "Re-payment",
            this.receiptData.rePaymentAmount * -1
          ),
          // , new BIllItemDescModel('Outstanding',this.receiptData.outstandingAmount)
        ]
      );
    }
  }

  getPatientChineseName() {
    if(!this.receiptData.invoices) return '';
    const { patientChiName, patientSurname, patientID } = this.receiptData.invoices[0].patient;
    const isNoChineseName = patientChiName === patientSurname;
    return isNoChineseName
      ? `${patientChiName} (${patientID})`
      : `${patientChiName}`;
  }

  getPatientEnglishName() {
    if(!this.receiptData.invoices) return '';
    const { patientChiName, patientSurname, patientID } = this.receiptData.invoices[0].patient;
    if (!patientSurname) return ` (${patientID})`;
    const isNoChineseName = patientChiName === patientSurname;
    return isNoChineseName ? `` : `${patientSurname} (${patientID})`;
  }

  cancel() {
    this.activeModal.close();
  }

  getOutstanding() {
    if (!this.receiptData.invoices) return "";
    const outstanding =
      this.receiptData.invoices[0].billAmount +
      this.receiptData.paymentMethods
        .map((x) => x.amount)
        .reduce((a, b) => a + b, 0);
    return this.currencyPipe.transform(outstanding, "HKD", "symbol", "1.0-1");
  }
}

export class ARAccountPaidBillReceiptModel {
  invoiceNumbers: string[];
  paDate: string;
  rePaymentAmount: number;
  outstandingAmount: number;
  paymentMethods: any[];
  patients: object[];
  invoices: InvoiceModel[];
  isFirstPA: boolean;
}

class BIllItemDescModel {
  itemDesc: string;
  itemArAmount: Number;

  constructor(itemDesc: string, itemArAmount: number) {
    this.itemDesc = itemDesc;
    this.itemArAmount = itemArAmount;
  }
}

class InvoiceModel {
  invoiceNumber: string;
  patient: {
    patientID: string;
    patientChiName: string;
    patientFirstName: string;
    patientSurname: string;
  };
  clthDiagonsis: string;
  clthTherapist: any;
  biDetails: BIllItemDescModel[];
  billAmount: number;
  consultationDate:string;
}
